import { ArrayLayoutProps, createDefaultValue } from "@jsonforms/core";
import { useContext, useEffect } from "react";
import { CollapsibleCardContext } from "../../CollapsibleCardLayout";
import { getMinItems } from "../utils";

export function DeleteItemsOnQuestionControlNoSelectedHandler(
  props: ArrayLayoutProps
) {
  const { lastQuestionControlValue } = useContext(CollapsibleCardContext);
  const minItems = getMinItems(props.minItems, props.uischema);
  const { options } = props.uischema;

  useEffect(() => {
    if (
      options?.deleteItemsOnQuestionControlNoSelected &&
      lastQuestionControlValue === false
    ) {
      if (props.data === 0) {
        return;
      }
      // TODO: this doesn't work properly with 10 or more items because React Aria has a bug where it deletes based on the alphabetical order of the indexes
      // I love the default behaviour of .sort()
      props.removeItems?.(
        props.path,
        Array.from({ length: props.data }, (_, i) => i)
      )();
      return;
    }
    // Adds any items that are required to meet the minimum item count
    const missingItems = Math.max(minItems - props.data, 0);

    for (let i = 0; i < missingItems; i++) {
      props.addItem(props.path, createDefaultValue(props.schema))();
    }
  }, [
    lastQuestionControlValue,
    options?.deleteItemsOnQuestionControlNoSelected,
    props.data,
    props.addItem,
    props.removeItems,
  ]);
  return <></>;
}
